
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.865 3.892A3.001 3.001 0 014 3a3 3 0 115.865.892zM19 15a3 3 0 100-6 3 3 0 000 6zM7 24a3 3 0 100-6 3 3 0 000 6zm9.005-7.996l-4.36 3.14a5.018 5.018 0 00-1.904-2.326l4.51-3.248a5.01 5.01 0 001.754 2.434zM8 7.9v8.2a5.022 5.022 0 00-3 .316V7.584A5.023 5.023 0 008 7.9zm8.005.096l-4.36-3.14A5.017 5.017 0 019.74 7.182l4.51 3.248a5.01 5.01 0 011.754-2.434z","fill":"#809D99"}})])
          )
        }
      }
    